// extracted by mini-css-extract-plugin
var _1 = "SwapConfirmation_boldText__P3uaD";
var _2 = "SwapConfirmation_bullet__0NKoR";
var _3 = "SwapConfirmation_bulletPoints__3+gKd";
var _4 = "SwapConfirmation_confirm__atkfC";
var _5 = "SwapConfirmation_faq__CQzEH";
var _6 = "768px";
var _7 = "SwapConfirmation_navigation__V3b2I";
var _8 = "SwapConfirmation_neverMind__APIkh";
var _9 = "'../../../shared.module.css'";
var _a = "SwapConfirmation_swapConfirmation__6EFPx";
var _b = "SwapConfirmation_terms__X2zm8";
var _c = "SwapConfirmation_title__9yU+A";
export { _1 as "boldText", _2 as "bullet", _3 as "bulletPoints", _4 as "confirm", _5 as "faq", _6 as "md", _7 as "navigation", _8 as "neverMind", _9 as "shared", _a as "swapConfirmation", _b as "terms", _c as "title" }
